import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import React, {
  useEffect,
  useState,
} from 'react';
import { TransitionGroup } from 'react-transition-group';
import FadeTransition from 'components/transitions/Fade';
import CommentCard from 'containers/cards/Comment';
import MediumCard from 'containers/cards/Medium';
import ReviewCard from 'containers/cards/Review';
// import {
//   extractTransactionError,
// } from 'lib/relayUtils';
// import tracker, {
//   TrackerFragments
//  } from 'lib/tracker';
// import DeleteCommunityCommentMutation from 'mutations/DeleteCommunityComment';
// import DeleteEventCommentMutation from 'mutations/DeleteEventComment';
// import DeleteMediumCommentMutation from 'mutations/DeleteMediumComment';
// import DeletePartyCommentMutation from 'mutations/DeletePartyComment';
// import DeleteReviewCommentMutation from 'mutations/DeleteReviewComment';
import InfiniteScrollApp from '../../components/InfiniteScrollerApollo';
import ProfilePage from './Page';
import { GET_PERSONAL_FEED } from '../../schema/apolloQueries/profileQueries';

const styles = {
  card: {
    marginBottom: 10,
  },
  cards: { width: '100%' },
};
// const onFailure = trackerData => transaction => {
//   const { message } = extractTransactionError(transaction);
//   tracker.trackGoogleAnalyticsException(message, trackerData);
// };
// const onSuccess = (category, trackerData) => () => tracker
//   .trackGoogleAnalyticsEvent(
//     'Communities',
//     'Delete comment',
//     trackerData,
//   );
const ProfileFeedPage = ({ viewer }) => {
  const size = 20;
  const { data, fetchMore } = useQuery(GET_PERSONAL_FEED, {
    variables: {
      pageNo: 1,
      size,
      onlyMyFeeds: true,
      sort: 'MOST_RECENT',
    },
  });

  const [isFirstLoad, setIsFirstLoad] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [resetPage, setResetPage] = useState(0);
  const [edges, setEdges] = useState([]);

  useEffect(() => {
    if (data?.getPersonalFeed) {
      setEdges(data?.getPersonalFeed?.feeds);
      setIsFirstLoad(false);
    }
  }, [data]);

  const onDelete = (index) => {
    setEdges(prevEdges => prevEdges.filter((_, i) => i !== index));
  };
  const handleFetchMore = (isPage, setHasMore) => {
    return new Promise((reslove, reject) => {
      fetchMore({
        variables: {
          pageNo: isPage,
          size,
          onlyMyFeeds: true,
          sort: 'MOST_RECENT',
        },
        updateQuery: (pre, { fetchMoreResult }) => {
          if (
            pre?.getPersonalFeed.feeds?.length
            >= fetchMoreResult?.getPersonalFeed?.count
          ) {
            setHasMore(false);
          } else {
            setHasMore(true);
          }
          return pre?.getPersonalFeed.feeds?.length
            >= fetchMoreResult?.getPersonalFeed?.count
            ? pre
            : {
              getPersonalFeed: {
                __typename: pre.getPersonalFeed.__typename,
                count: pre.getPersonalFeed.count,
                feeds: [
                  ...pre.getPersonalFeed.feeds,
                  ...fetchMoreResult.getPersonalFeed.feeds,
                ],
              },
            };
        },
      })
        .then(() => {
          reslove();
        })
        .catch(() => {
          reject();
        });
    });
  };
  const setLikeOrUnlikeEdgesState = (index) => {
    setEdges(prevEdges => {
      const newList = [...prevEdges];
      newList[index] = {
        ...newList[index],
        feedInfo: {
          ...newList[index].feedInfo,
          liked: !newList[index].feedInfo.liked, // Use newList[index] instead of feed
          likeCount: !newList[index].feedInfo.liked ? newList[index].feedInfo.likeCount + 1 : newList[index].feedInfo.likeCount - 1, // Use newList[index] instead of feed
        },
      };
      return newList;
    });
  };
  const setCommentEdgesState = (index, feed) => {
    setEdges(prevEdges => {
      const newList = [...prevEdges];
      newList[index] = {
        ...newList[index],
        commentInfo: { ...newList[index].commentInfo, body: feed },
      };
      return newList;
    });
  };
  const setCommentCountEdgesState = (index) => {
    setEdges(prevEdges => {
      const newList = [...prevEdges];
      newList[index] = {
        ...newList[index],
        feedInfo: { ...newList[index].feedInfo, commentCount: newList[index].feedInfo.commentCount + 1 },
      };
      return newList;
    });
  };
  return (
    <ProfilePage title='Feed' viewer={viewer}>
      <InfiniteScrollApp
        getPage={resetPage}
        handleFetchMore={handleFetchMore}
        isFirstLoad={isFirstLoad}
        isEmpty={data?.getPersonalFeed?.feeds?.length === 0}
      >
        <TransitionGroup style={styles.cards}>
          {edges.map(
            (comment, index) => {
              if (comment.feedType === 'Discussion') {
                return (
                  <FadeTransition key={comment.id}>
                    <CommentCard
                      comment={comment}
                      onDelete={() => onDelete(index)}
                      onLikeOrUnlike={() => {
                        setLikeOrUnlikeEdgesState(index);
                      }}
                      onEditComment={(feed) => {
                        setCommentEdgesState(index, feed);
                      }}
                      onReplyCount={() => {
                        setCommentCountEdgesState(index);
                      }}
                      style={styles.card}
                      viewer={viewer}
                    />
                  </FadeTransition>
                );
              }
              if (comment.feedType === 'SocialAsset') {
                return (
                  <FadeTransition key={comment.id}>
                    <MediumCard
                      onLikeOrUnlike={(feed) => {
                        setLikeOrUnlikeEdgesState(index, feed);
                      }}
                      onCommentCount={() => {
                        setCommentCountEdgesState(index);
                      }}
                      medium={comment}
                      style={styles.card}
                      viewer={viewer}
                    />
                  </FadeTransition>
                );
              }
              if (comment.feedType === 'Review') {
                return (
                  <FadeTransition key={comment.id}>
                    <ReviewCard
                      onLikeOrUnlike={(feed) => {
                        setLikeOrUnlikeEdgesState(index, feed);
                      }}
                      onCommentCount={() => {
                        setCommentCountEdgesState(index);
                      }}
                      review={comment}
                      style={styles.card}
                      viewer={viewer}
                    />
                  </FadeTransition>
                );
              }
              return null;
            },
          )}
        </TransitionGroup>
      </InfiniteScrollApp>
    </ProfilePage>
  );
};

ProfileFeedPage.propTypes = {
  router: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
};

export default ProfileFeedPage;
